export interface Comment {
  id: string;
  author: CommentAuthor;
  text: string;
  timestamp: Date;
  context?: string; // e.g., "Total Revenue (Line 9)", "Employer identification number"
  replies?: Comment[];
  entityId: number;
  entityType: MessageEntityType;
  parentMessageId?: string | null; // ID of parent message if this is a reply
  isUnread?: boolean;
  isMasked?: boolean;
  createdAt?: string;
}

export interface CommentAuthor {
  id: string;
  firstName: string;
  lastName: string;
  extraInfo?: string;
  isStaff?: boolean; // Used to determine avatar domain
}

export interface CommentSectionItem extends Comment {
  id: string | null;
  flaggedFiles?: string[];
  isComment: boolean;
}

/**
 * Message entity types supported by the API
 * Based on database enum: message_entity_type
 */
export enum MessageEntityType {
  CLIENT_REQUEST_ITEM = 'CLIENT_REQUEST_ITEM',
  ENGAGEMENT = 'ENGAGEMENT',
  JOB = 'JOB',
}

/**
 * Payload for posting a comment with entity context
 */
export interface PostCommentPayload {
  text: string;
  parentId?: string; // For replies
  context?: string;
  entityId: number;
  entityType: MessageEntityType;
}
